export const FINANCING_MANAGER_PHONE = '88007070385'
